import { cn } from "@/lib/utils";
import { VariantProps, cva } from "class-variance-authority";
import { HTMLAttributes, forwardRef } from "react";

const typographyVariants = cva("", {
  variants: {
    variant: {
      h3: "scroll-m-20 text-2xl leading-6 tracking-[-0.015em]",
      body: "text-sm leading-5",
      bodyMuted: "text-sm text-muted-foreground leading-5",
      bodyRegular: "text-sm font-600 leading-6",
      bodyBold: "text-sm font-700 leading-6",
    },
    alignment: {
      left: "text-left",
      center: "text-center",
    },
  },
  defaultVariants: {
    variant: "body",
    alignment: "left",
  },
});

interface TypographyProps
  extends HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof typographyVariants> {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
}

const Typography = forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ className, variant, as: Component = "p", alignment, ...props }, ref) => {
    return (
      <Component
        ref={ref}
        className={cn(typographyVariants({ variant, alignment }), className)}
        {...props}
      />
    );
  }
);

Typography.displayName = "Typography";

export { Typography, typographyVariants };
